// Frontend IntersectionObserver for the entrance-animation pattern.
// The inline <head> script (see php/enqueue-assets.php) already gated
// the marker class on IntersectionObserver support + non-reduced-motion,
// so this script only needs to wire up the observer — the CSS handles
// the no-marker fallback by leaving blocks visible.

const VISIBLE_CLASS = 'is-entrance-visible';

function initEntranceAnimations() {
    const blocks = Array.from(
        document.querySelectorAll<HTMLElement>('.has-entrance-animation')
    );
    if (!blocks.length) return;

    const reveal = (el: HTMLElement) => el.classList.add(VISIBLE_CLASS);

    // Defensive: the inline head script also gated on these, but if
    // we ever reach here without IO support / with reduced motion, just
    // reveal every block immediately so nothing stays hidden.
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        blocks.forEach(reveal);
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                reveal(entry.target as HTMLElement);
                observer.unobserve(entry.target);
            });
        },
        {
            // Trigger once the block has scrolled into the top ~90% of the
            // viewport. Conservative bottom margin so short pages still
            // trigger the last block.
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.15,
        }
    );

    blocks.forEach((block) => observer.observe(block));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEntranceAnimations);
} else {
    initEntranceAnimations();
}
